'use client'

import { cn } from '@/lib/utils'
import { Typo3SectionSpotSanityContentText } from '@/types/typo3'
import { Img, SliderImage } from '@/ui/components'

import { memo } from 'react'

interface Props {
  data: Typo3SectionSpotSanityContentText['content']['images']
}

const ImageSlide = ({ data }: Props) => {
  if (data?.length) {
    if (data?.length > 1) {
      return <SliderImage data={data} />
    } else {
      return (
        <>
          <Img
            data={data[0]}
            objectCover
            className="w-full"
            naked
            sizes="87rem"
          />

          {data?.[0].properties?.description ||
            (data?.[0].properties?.title && (
              <div className={cn('text-small', 'mt-4 h-5 text-neutral-400')}>
                {data?.[0].properties?.description !== ''
                  ? data?.[0].properties?.description
                  : data?.[0].properties?.title}
              </div>
            ))}
        </>
      )
    }
  }
}

export default memo(ImageSlide)
